<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import moment from "moment";

export default {
	page: {
		title: 'Движение денежных средств',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: 'Движение денежных средств',
            items: [],
            tableData: [],
            currentPage: 1,
            perPage: 50,
            pageOptions: [10, 25, 50, 100, 500],
            filter: null,
            filterOn: null,
            type: null,
            isCompany: false,
            sortBy: null,
            sortDesc: true,

            dateConfig: {
                mode: 'range',
                locale: Russian,
                dateFormat: 'd.m.Y',
            },

            tableLoading: true,
            watch: false,

            date_start: null,
            date_end: null,
            selectedDate: [],
		}
	},

    watch: {
        '$route.params.type': {
            immediate: false,
            async handler() {
                this.applyRouteState();
                await this.getData();
            }
        },
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['finance/GET_FINANCE_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['finance/GET_FINANCE_TABLE_DATA'];
        },
        operation_type() {
            const map = {
                payin: 'income',
                payout: 'expense',
                moving: 'transfer',
                income: 'income',
                expense: 'expense',
                transfer: 'transfer',
            };
            return this.type && map[this.type] ? map[this.type] : null;
        },
        table_fields() {
            const base = [
                { key: 'select', label: '', row:{'rowSelected':false}},
                { key: 'created_at', label: 'Дата', sortable: true },
                { key: 'finance_type_name', label: 'Категория', sortable: true },
                { key: 'company_name', label: 'Компания', sortable: true },
                { key: 'counterparty_name', label: 'Контрагент', sortable: true },
            ];

            const fromFields = [
                { key: 'bank_account_from', label: 'Счет списания', sortable: true },
                { key: 'currency_from_code', label: 'Валюта списания', sortable: true },
            ];
            const toFields = [
                { key: 'bank_account_to', label: 'Счет зачисления', sortable: true },
                { key: 'currency_to_code', label: 'Валюта зачисления', sortable: true },
            ];
            const tail = [
                { key: 'sum', label: 'Сумма', sortable: true },
                { key: 'status', label: 'Статус'},
                { key: 'comments', label: 'Комментарий', sortable: true },
                { key: 'updated_at', label: 'Обновлено', sortable: true },
                { key: 'action', label: ''},
            ];

            if (this.operation_type === 'income') return [...base, ...toFields, ...tail];
            if (this.operation_type === 'expense') return [...base, ...fromFields, ...tail];
            if (this.operation_type === 'transfer') return [...base, ...fromFields, ...toFields, ...tail];
            return [...base, ...fromFields, ...toFields, ...tail];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    async mounted() {
        this.applyRouteState();
        await this.getData();
    },

    methods: {
        applyRouteState() {
            this.type = this.$route.params.type ? this.$route.params.type : null;

            const titleMap = {
                payin: 'Доходы',
                income: 'Доходы',
                payout: 'Расходы',
                expense: 'Расходы',
                moving: 'Перемещения',
                transfer: 'Перемещения',
            };

            this.title = this.type && titleMap[this.type] ? titleMap[this.type] : 'Движение денежных средств';
        },

        mapRouteType(value) {
            const map = {
                payin: { type: 'income' },
                payout: { type: 'expense' },
                moving: { type: 'transfer' },
                income: { type: 'income' },
                expense: { type: 'expense' },
                transfer: { type: 'transfer' },
            };
            return value && map[value] ? map[value] : { type: null };
        },

        async onChangePeriod(item){
            if(item[0] && item[1]){
                this.date_start = moment(item[0]).format('DD.MM.YYYY')
                this.date_end   = moment(item[1]).format('DD.MM.YYYY')
                await this.getData();
            }
        },

        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;

            const routeType = this.mapRouteType(this.type);
            let data_send = {
                'limit'      : this.perPage,
                'page'       : this.currentPage,
                'sortBy'     : this.sortBy,
                'sortDesc'   : this.sortDesc === false ? 'ASC' : 'DESC'
            }
            if (this.date_start && this.date_end) {
                data_send.date_start = this.date_start;
                data_send.date_end = this.date_end;
            }

            if (this.filter) {
                data_send.filter = this.filter;
            }
            if (Array.isArray(this.filterOn) && this.filterOn.length > 0) {
                data_send.filterOn = JSON.stringify(this.filterOn);
            }
            if (routeType.type) {
                data_send.type = routeType.type;
            }

            await this.$store.dispatch('finance/FETCH_FINANCE_LIST', data_send);
            this.watch = true;
        },
        async delItem(uuid){
            await this.$store.dispatch('finance/FETCH_FINANCE_DELETE', {uuid: uuid});
            await this.getData();
            return false;
        },        
    }
}

</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-12 col-xl-4">
                <h4 class="mb-1 mt-0">{{ title }}</h4>
            </div>

            <div class="col-sm-12 col-xl-8">
                <form class="form-inline float-sm-right mt-3 mt-sm-0">
                    <div class="btn-group" style="float: right">
                        <b-button to="/account/finance/create" variant="primary" right>
                            <i class="uil uil-bill mr-1"></i>Новая операция
                        </b-button>
                    </div>
                </form>
            </div>

        </div>
        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-3 col-md-3">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-9 col-md-9">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <div class="form-group mb-sm-0">
                                <label class="d-inline-flex align-items-center">
                                    Период: 
                                    <flat-pickr
                                        v-model="selectedDate"
                                        class="form-control ml-2"
                                        :config="dateConfig"
                                        @on-change="onChangePeriod"
                                        name="date"
                                    ></flat-pickr>
                                </label>
                                <label class="ml-3 d-inline-flex align-items-center">
                                    Поиск: 
                                    <b-form-input
                                        v-model="filter"
                                        type="search"
                                        @change="onFiltered()"
                                        placeholder="Введите текст..."
                                        class="form-control form-control-md ml-2"
                                    ></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">
                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="table_fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                            >
                                <template #cell(action)="row">
                                    <b-dropdown
                                        variant="link"
                                        class="float-right"
                                        right
                                        toggle-class="p-0 text-muted arrow-none"
                                    >
                                        <template v-slot:button-content>
                                            <i class="uil uil-ellipsis-v font-size-14"></i>
                                        </template>
                                        <b-dropdown-item :to="{ name: 'Finance.edit', params: { finance_uuid: row.item.uuid, copy: true }}"
                                            ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                        >
                                        <b-dropdown-item href="javascript: void(0);" @click.native="delItem(row.item.uuid)" variant="danger">
                                            <i class="uil uil-trash mr-2"></i>Удалить
                                        </b-dropdown-item>
                                    </b-dropdown>                                    
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>